module.exports = __webpack_public_path__ + "assets/img/mecha-28daf247.png";